import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import CacheService from "@/services/cacheService";
import FeatureFlagService from "@/services/featureFlagService";
import LogService from "@/services/logService";

@Component({
    components: {
        fieldsetComponent,
        comboComponent,
        gridComponent,
    },
})
export default class AdminComponent extends Vue {
    private logService = new LogService();
    private cacheService = new CacheService();
    private featureFlagService = new FeatureFlagService();

    logLevel = "";
    newLogLevel = 0;
    gridData = [];

    newLogLevelOptions = [
        { text: "Verbose", value: 1 },
        { text: "Debug", value: 2 },
        { text: "Information", value: 3 },
        { text: "Warning", value: 4 },
        { text: "Error", value: 5 },
        { text: "Fatal", value: 6 },
    ];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("name", "Nome", GridColumnType.String),
            new GridColumn("isEnabled", "Habilitado", GridColumnType.Boolean),
            new GridColumn("conditions", "Condições", GridColumnType.String),
        ];
    }

    private async mounted() {
        const response = await this.logService.getLogLevel().withLoading().resolveWithJSON<{ level: string }>();

        this.logLevel = response.level;

        await this.getListFeatureFlags();
    }

    private async limparCacheProdutos() {
        try {
            await this.cacheService.limparCacheProdutos().withLoading().resolveWithoutJSON();

            await this.$showSuccess(this.$t("__.ts.sucesso"), "Cache removido com sucesso!");
        } catch {}
    }

    private async limparCacheProdutosManipulacao() {
        try {
            await this.cacheService.limparCacheProdutosManipulacao().withLoading().resolveWithoutJSON();

            await this.$showSuccess(this.$t("__.ts.sucesso"), "Cache removido com sucesso!");
        } catch {}
    }

    private async getListFeatureFlags() {
        try {
            const response = await this.featureFlagService.list().withLoading().resolveWithJSON<any[]>();
            this.gridData = response.map(item => {
                const allConditions: string[] = [];

                item.conditions.forEach(condition => {
                    Object.entries(condition.parameters).forEach(([key, value]) => {
                        allConditions.push(`${key}: ${value}`);
                    });
                });

                return {
                    name: item.name,
                    isEnabled: item.isEnabled,
                    conditions: allConditions.join("; "),
                };
            });
        } catch {}
    }

    private async updateLogLevel() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                await this.logService.setLogLevel(this.newLogLevel).withLoading();

                this.$router.back();
            }
        } catch {}
    }
}
